module.exports = __webpack_public_path__ + "static/media/국사봉.4aa97fd4.jpg";